import { Form, Select, Typography } from 'antd';
import cn from 'classnames';

import { useDictionary } from '../../../hooks/useDictionary';

import type { MedicalDictionaryType } from '../../../data';

const { Text } = Typography;

type Props = {
  type: MedicalDictionaryType;
  title?: string;
  required?: boolean;
  name: string | number | (string | number)[];
  disabled?: boolean;
  validateStatus?: 'success' | 'warning' | 'error' | 'validating';
  placeholder?: string;
  isStatic?: boolean;
  isStrongTitle?: boolean;
  initialValue?: string;
};

export const DictionarySelect = ({
  type,
  title,
  required,
  name,
  disabled,
  validateStatus,
  placeholder = 'Введите минимум 3 символа для поиска',
  isStatic = false,
  isStrongTitle = true,
  initialValue,
}: Props) => {
  const formValue = Form.useWatch(name);

  const { options, isLoading, onSearch } = useDictionary(
    type,
    initialValue || formValue,
    isStatic
  );

  return (
    <div className="field-container">
      <Text
        className={cn('required-label', { 'label-require': required })}
        strong={isStrongTitle}
      >
        {title}
      </Text>

      <Form.Item
        name={name}
        rules={[{ required, message: 'Пожалуйста, выберите значение' }]}
        validateStatus={validateStatus}
      >
        <Select
          showSearch
          placeholder={placeholder}
          loading={isLoading}
          filterOption={false}
          onSearch={onSearch}
          disabled={disabled}
          size="large"
          options={options.map((item) => ({
            value: item.Code,
            label: item.Name,
          }))}
        />
      </Form.Item>
    </div>
  );
};
